export default "__VITE_ASSET__Drknso6c__"